import { Printer } from 'lucide-react';
import { calcularTextoConRelleno } from '../rellenoTexto';
import ChequeLienzo from './ChequeLienzo';

export default function VistaPreviaImpresion({ preparando, onCancelar, onConfirmar }) {
  if (!preparando) return null;
  const { cheque, banco, calibracion } = preparando;

  const montoFormateado = Number(cheque.monto_numero).toLocaleString('en-US', { minimumFractionDigits: 2 });
  const fechaTexto = `${cheque.ciudad ? cheque.ciudad + ' ' : ''}${cheque.fecha_emision}`;
  const { textoFinal: montoTexto } = calcularTextoConRelleno({
    texto: cheque.monto_texto,
    relleno: calibracion.relleno_char,
    fuentePt: Number(calibracion.fuente_pt),
    anchoMm: Number(calibracion.texto_w),
  });

  const numeroComprobante = cheque.numero_comprobante
    ? `N.º ${String(cheque.numero_comprobante).padStart(4, '0')}`
    : '—';

  return (
    <>
      <div className="modal-fondo no-imprimir" onClick={onCancelar} />
      <div className="modal-ventana">
        <h4 className="no-imprimir">Vista previa de impresión</h4>
        <p className="ayuda no-imprimir">Comprobante de egreso asociado: {numeroComprobante}</p>
        <div className="preview-area no-imprimir-fondo">
          <ChequeLienzo
            banco={banco}
            calibracion={calibracion}
            fecha={fechaTexto}
            nombre={cheque.beneficiario}
            montoFormateado={montoFormateado}
            montoTexto={montoTexto}
          />
        </div>
        <div className="acciones-nuevo-banco no-imprimir">
          <button type="button" className="btn-secundario" onClick={onCancelar}>Cerrar</button>
          <button type="button" className="btn-primary" onClick={onConfirmar}>
            <Printer size={16} /> Confirmar e imprimir
          </button>
        </div>
      </div>
    </>
  );
}
